import { render } from "./KalaStore.vue?vue&type=template&id=ca4c3072"
import script from "./KalaStore.vue?vue&type=script&lang=js"
export * from "./KalaStore.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__